import Vue from 'vue'
import Vuex from 'vuex'
import 'babel-polyfill'
import bookings from "./store/bookings";
import firebase from '@/config/db.js';

Vue.use(Vuex);
const state = {};
export default new Vuex.Store({
    state,
    modules: {
        bookings: bookings,
		user: {
			loggedIn: false,
			data: null,
			extra: {}
		}
    },
	getters: {
		user(state){
			return state.user
		}
	},
	mutations: {
		SET_LOGGED_IN(state, value) {
			state.user.loggedIn = value;
		},
		SET_USER(state, data) {
			state.user.data = data;
		},
		SET_USER_DATA(state, data) {
			state.user.extra = data;
		}
	},
    actions: {
        init: async function (context) {
            return new Promise(resolve => {
                context.dispatch('bookings/getReservations').then(() => resolve());
            })
        },
        async getUserData({rootState, commit}) {
			if (rootState.user) {
				let userRef = firebase.firestore().collection("users").doc(rootState.user.data.uid);
				await userRef.get().then((doc) => {
					if (doc.exists) {
                        commit('SET_USER_DATA', doc.data());
					} else {
						let currentUser = firebase.auth().currentUser;
						firebase.auth().signOut().then(() => {
							if (currentUser.email) window.location.reload();
						});
					}
				}).catch((error) => {
					let currentUser = firebase.auth().currentUser;
					firebase.auth().signOut().then(() => {
						if (currentUser.email) window.location.reload();
					});
				});
			}
        },
		fetchUser({ commit }, user) {
			commit("SET_LOGGED_IN", user !== null);
			if (user) {
				commit("SET_USER", {
					uid: user.uid,
					displayName: user.displayName,
					email: user.email
				});
			} else {
				commit("SET_USER", null);
			}
		},
        logout({commit}) {
            return new Promise(resolve => {
                let currentUser = firebase.auth().currentUser;
                firebase.auth().signOut().then(() => {
                    if (currentUser.email) window.location.reload();
                    else {
                        commit('logout');
                        resolve();
                    }
                });
            });
        }
    }
})
